// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#onboarding-step1-container {
  font-size: 16px;
  font-weight: 100;
  margin-right: 5vw;
  max-width: 740px
}

@media (max-width: 707px) {

#onboarding-step1-container {
    margin-right: 0
}
  }

#upper__header {
  font-size: 24px;
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 30px;
}
.text--bold {
  font-weight: 700;
}

#select-platform {
  display: flex;
  flex-direction: row;
  margin-top: 15px
}

@media (max-width: 697px) {

#select-platform {
    margin-bottom: 20px
}
  }

@media (max-width: 707px) {

#select-platform {
    flex-direction: column
}
  }

#select-platform__mobile-side-by-side {
  display: flex;
}

#select-platform__text-container {
  display: flex;
  flex-direction: column;
  width: 70%;
  padding-top: 22px;
}

#header {
  font-size: 34px;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 20px
}

@media (max-width: 707px) {

#header {
    font-size: 24px;
    margin-top: 10px;
    margin-bottom: 15px
}
  }

#select-platform__text {
  margin-bottom: 20px
}

@media (max-width: 707px) {

#select-platform__text {
    flex-shrink: 3;
    display: flex;
    align-items: center;
    padding-left: 0.5rem;
    margin-bottom: 0
}
  }
#select-platform__narrow-container {
  width: 75%;
  min-width: 100px;
  max-width: 640px
}
@media (max-width: 707px) {
#select-platform__narrow-container {
    width: 100%;
    max-width: 100%
}
  }
#interactive-section {
  margin-left: 180px
}
@media (max-width: 707px) {
#interactive-section {
    margin-left: 0
}
  }

#instructions-text {
  /* margin-left: \$margin-for-icon; */
}

#dropdown {
  position: relative;
  margin-bottom: 20px
}

@media (max-width: 707px) {

#dropdown {
    margin-top: 20px
}
  }
#dropdown__select-box {
  background-color: #f8f8f8;
  padding: 10px;
  border-radius: 6px;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  position: relative;
}
#dropdown__options {
  position: absolute;
  top: 0;
  width: 100%;
  background-color: #f8f8f8;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  margintop: 4px;
}
.dropdown__option {
  padding: 8px;
  height: 40px;
  cursor: pointer;
}
.dropdown__option.dropdown__option:hover {
    background-color: #e2e8f0;
  }

#button {
  margin-top: 40px;
  margin-bottom: 20px
}

@media (max-width: 707px) {

#button {
}
  }
`, "",{"version":3,"sources":["webpack://./src/pages/Onboarding/Step1.pcss"],"names":[],"mappings":"AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB;AAIF;;AAHE;;AALF;IAMI;AAEJ;EADE;;AAGF;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AAOF;;AANE;;AAJF;IAKI;AAKJ;EAJE;;AACA;;AAPF;IAQI;AAEJ;EADE;;AAGF;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb;AAMF;;AALE;;AALF;IAMI,eAAe;IACf,gBAAgB;IAChB;AAEJ;EADE;;AAGF;EACE;AAQF;;AAPE;;AAFF;IAGI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB;AAEJ;EADE;AAEF;EACE,UAAU;EACV,gBAAgB;EAChB;AAKF;AAJE;AAJF;IAKI,WAAW;IACX;AAEJ;EADE;AAEF;EACE;AAIF;AAHE;AAFF;IAGI;AAEJ;EADE;;AAGF;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB;AAIF;;AAHE;;AAHF;IAII;AAEJ;EADE;AAEF;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AAIjB;AAHE;IACE,yBAAyB;EAC3B;;AAGF;EACE,gBAAgB;EAChB;AAGF;;AAFE;;AAHF;AAKA;EADE","sourcesContent":["$margin-for-icon: 180px;\n$mobile: 707px;\n\n#onboarding-step1-container {\n  font-size: 16px;\n  font-weight: 100;\n  margin-right: 5vw;\n  max-width: 740px;\n  @media (max-width: $mobile) {\n    margin-right: 0;\n  }\n}\n\n#upper__header {\n  font-size: 24px;\n  font-weight: 400;\n  margin-top: 0px;\n  margin-bottom: 30px;\n}\n.text--bold {\n  font-weight: 700;\n}\n\n#select-platform {\n  display: flex;\n  flex-direction: row;\n  margin-top: 15px;\n  @media (max-width: 697px) {\n    margin-bottom: 20px;\n  }\n  @media (max-width: $mobile) {\n    flex-direction: column;\n  }\n}\n\n#select-platform__mobile-side-by-side {\n  display: flex;\n}\n\n#select-platform__text-container {\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  padding-top: 22px;\n}\n\n#header {\n  font-size: 34px;\n  font-weight: 700;\n  margin-top: 0;\n  margin-bottom: 20px;\n  @media (max-width: $mobile) {\n    font-size: 24px;\n    margin-top: 10px;\n    margin-bottom: 15px;\n  }\n}\n\n#select-platform__text {\n  margin-bottom: 20px;\n  @media (max-width: $mobile) {\n    flex-shrink: 3;\n    display: flex;\n    align-items: center;\n    padding-left: 0.5rem;\n    margin-bottom: 0;\n  }\n}\n#select-platform__narrow-container {\n  width: 75%;\n  min-width: 100px;\n  max-width: 640px;\n  @media (max-width: $mobile) {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n#interactive-section {\n  margin-left: 180px;\n  @media (max-width: $mobile) {\n    margin-left: 0;\n  }\n}\n\n#instructions-text {\n  /* margin-left: $margin-for-icon; */\n}\n\n#dropdown {\n  position: relative;\n  margin-bottom: 20px;\n  @media (max-width: $mobile) {\n    margin-top: 20px;\n  }\n}\n#dropdown__select-box {\n  background-color: #f8f8f8;\n  padding: 10px;\n  border-radius: 6px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n}\n#dropdown__options {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  background-color: #f8f8f8;\n  border: 1px solid #cbd5e0;\n  border-radius: 4px;\n  margintop: 4px;\n}\n.dropdown__option {\n  padding: 8px;\n  height: 40px;\n  cursor: pointer;\n  &&:hover {\n    background-color: #e2e8f0;\n  }\n}\n\n#button {\n  margin-top: 40px;\n  margin-bottom: 20px;\n  @media (max-width: $mobile) {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
